import React from 'react';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  elevated?: boolean;
};

export const Card: React.FC<Props> = ({ elevated = false, className = '', children, ...rest }) => (
  <div
    {...rest}
    className={[
      'bg-surface-card rounded-md p-4',
      elevated ? 'shadow-elev-2' : 'shadow-elev-1',
      className,
    ].join(' ')}
  >
    {children}
  </div>
);
